/**
 * @generated SignedSource<<382ed42126e90c7515d7f2f83076b7f7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type hooksRemoveReadingHistoryArticle$data = {
  readonly entityId: string;
  readonly entityUuid: string;
  readonly " $fragmentType": "hooksRemoveReadingHistoryArticle";
};
export type hooksRemoveReadingHistoryArticle$key = {
  readonly " $data"?: hooksRemoveReadingHistoryArticle$data;
  readonly " $fragmentSpreads": FragmentRefs<"hooksRemoveReadingHistoryArticle">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "hooksRemoveReadingHistoryArticle"
};

(node as any).hash = "9cf9cb93788ef385dc0937902f020c9b";

export default node;
